import { Container, Row, Col, Image } from 'react-bootstrap'

const PhysiciansDiseasedOriented = () => (
    <>
    <div className="section-physicians-are">
        <Container>
            <h2>Physicians are disease oriented...</h2>
                <Row>
                    <Col lg={7} md={8}>
                        <p>I have the utmost respect for Doctors, but as important <br className="d-none d-xl-block"/>
                        and helpful as Physicians are, the truth is, they're disease oriented. </p>
                        <p><strong>They study disease. They look for disease.</strong></p>
                        <p>They're pharmaceutically trained to treat disease. <br className="d-none d-xl-block"/>
                        And in order to do so, they know their drugs.</p>
                        <p>They learn the side-effects of drugs, and they work carefully <br className="d-none d-xl-block"/>
                        to balance the benefits against any potential danger. <br className="d-none d-xl-block"/>
                        Physicians know their drugs and don't hesitate to prescribe them. </p>
                        <p>A study estimates that in 1997, pharmacies filled more than <br className="d-none d-xl-block"/>
                        2.5 billion retail prescriptions in the United States alone. </p>
                        <p>The sale of prescription drugs has more than doubled <br className="d-none d-xl-block"/>
                        in just the past eight years! </p>
                        <div className="testimonial">
                            <p>"This was really helpful! <br/>
                                I really enjoyed the information found in this report."<br/>
                            - Sarah F. </p>
                        </div>
                    </Col>
                    <Col lg={5} md={4}>
                        <Image src="../images/wyd/img-ebook-doctor08.png" alt="What your Doctor" className="img-fluid d-block w-auto mx-auto"/>
                    </Col>
                </Row>
        </Container>
    </div>
    <style jsx global>{`

            .section-physicians-are {
                font-size: 18px;
                background: #fff;
            }

            .section-physicians-are .container {
                padding-top: 60px;
            }

            .section-physicians-are h2 {
                color: #00aec7;
                font-size: 42px;
                margin-bottom: 35px;
                letter-spacing: 1px;
            }

            .section-physicians-are p {
                margin-bottom: 30px;
            }

            .section-physicians-are .testimonial {
                max-width: 580px;
                background: #f3f3f3 url(../images/wyd/bg-quote01.png) no-repeat top right;
                padding: 20px 15px 1px;
                margin-bottom: 40px;
            }

            @media (max-width: 767.98px) {	

                .section-physicians-are img {
                    width: 80% !important;
                }

            }

        `}</style>
    </>
);

export default PhysiciansDiseasedOriented;